module.exports = __webpack_public_path__ + "static/media/card-blog15.2db8ae9b.jpg";